import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';

export const GET_MATERIALS_REQUEST = 'GET_MATERIALS_REQUEST';
export const GET_MATERIALS_SUCCESS = 'GET_MATERIALS_SUCCESS';
export const GET_MATERIALS_ERROR = 'GET_MATERIALS_ERROR';

export const GET_MATERIAL_REQUEST = 'GET_MATERIAL_REQUEST';
export const GET_MATERIAL_SUCCESS = 'GET_MATERIAL_SUCCESS';
export const GET_MATERIAL_ERROR = 'GET_MATERIAL_ERROR';

export const CREATE_MATERIAL_REQUEST = 'CREATE_MATERIAL_REQUEST';
export const CREATE_MATERIAL_SUCCESS = 'CREATE_MATERIAL_SUCCESS';
export const CREATE_MATERIAL_ERROR = 'CREATE_MATERIAL_ERROR';

export const UPDATE_MATERIAL_REQUEST = 'UPDATE_MATERIAL_REQUEST';
export const UPDATE_MATERIAL_SUCCESS = 'UPDATE_MATERIAL_SUCCESS';
export const UPDATE_MATERIAL_ERROR = 'UPDATE_MATERIAL_ERROR';

export const DELETE_MATERIAL_REQUEST = 'DELETE_MATERIAL_REQUEST';
export const DELETE_MATERIAL_SUCCESS = 'DELETE_MATERIAL_SUCCESS';
export const DELETE_MATERIAL_ERROR = 'DELETE_MATERIAL_ERROR';

export const CLEAN_MATERIALS = 'CLEAN_MATERIALS';

// Get materials
export function getMaterials(query) {
    return async (dispatch) => {
        try {
            dispatch(getMaterialsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/materials/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getMaterialsSuccess, getMaterialsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getMaterialsError));
        }
    };
}
function getMaterialsRequest() {
    return {
        type: GET_MATERIALS_REQUEST,
        isFetching: true
    };
}
function getMaterialsSuccess (payload) {
    return {
        type: GET_MATERIALS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getMaterialsError(errorMessage) {
    return {
        type: GET_MATERIALS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get material
export function getMaterial(materialId) {

    return async (dispatch) => {
        try {
            dispatch(getMaterialRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/materials/${materialId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getMaterialSuccess, getMaterialError));
        } catch (err) {
            dispatch(utilsLib.response(err, getMaterialError));
        }
    };
}
function getMaterialRequest() {
    return {
        type: GET_MATERIAL_REQUEST,
        isFetching: true
    };
}
function getMaterialSuccess (payload) {
    return {
        type: GET_MATERIAL_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getMaterialError(errorMessage) {
    return {
        type: GET_MATERIAL_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create material
export function createMaterial(material) {
    return async (dispatch) => {
        try {
            dispatch(createMaterialRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/materials', material, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createMaterialSuccess, createMaterialError));
        } catch (err) {
            dispatch(utilsLib.response(err, createMaterialError));
        }
    };
}
function createMaterialRequest() {
    return {
        type: CREATE_MATERIAL_REQUEST,
        isFetching: true
    };
}
function createMaterialSuccess (payload) {
    return dispatch => {
        // Create notification for create material success
        dispatch(addNotification({
            message: 'Material añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_MATERIAL_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createMaterialError(errorMessage) {
    return dispatch => {
        // Create notification for create material error
        dispatch(addNotification({
            message: 'Error al añadir el material',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_MATERIAL_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update material
export function updateMaterial(materialId, material = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateMaterialRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/materials/${materialId}`, material, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateMaterialSuccess, updateMaterialError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateMaterialError));
        }
    };
}
function updateMaterialRequest() {
    return {
        type: UPDATE_MATERIAL_REQUEST,
        isFetching: true
    };
}
function updateMaterialSuccess (payload) {
    return dispatch => {
        // Create notification for update material success
        dispatch(addNotification({
            message: 'Material actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_MATERIAL_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateMaterialError(errorMessage) {
    return dispatch => {
        // Create notification for update material error
        dispatch(addNotification({
            message: 'Error al actualizar el material',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_MATERIAL_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete material
export function deleteMaterial(materialId) {

    return async (dispatch) => {
        try {
            dispatch(deleteMaterialRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/materials/${materialId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteMaterialSuccess, deleteMaterialError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteMaterialError));
        }
    };
}
function deleteMaterialRequest() {
    return {
        type: DELETE_MATERIAL_REQUEST,
        isFetching: true
    };
}
function deleteMaterialSuccess (payload) {
    return dispatch => {
        // Create notification for delete material success
        dispatch(addNotification({
            message: 'Material eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_MATERIAL_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteMaterialError(errorMessage) {
    return dispatch => {
        // Create notification for delete material error
        dispatch(addNotification({
            message: 'Error al eliminar el material',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_MATERIAL_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean materials reducer
export function cleanMaterials() {
    return {
        type: 'CLEAN_MATERIALS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/materials.js